export const initialState = {};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitAuthorizations':
      return onInitAuthorizations(state, action);
    case 'OnInitUserGroups':
      return onInitUserGroups(state, action);
    case 'OnInitChangedPermissions':
      return OnInitChangedPermissions(state, action);
    case 'OnInitDisabledSave':
      return OnInitDisabledSave(state, action);
    case 'OnSetAuthorizationXUserGroupValue':
      return onSetAuthorizationXUserGroupValue(state, action);
    case 'OnSetAll':
      return onSetAll(state, action);
    case 'OnSaveAuthorizationsXUserGroups':
      return onSaveAuthorizationsXUserGroups(state);
    case 'OnUnrefineAuthorization':
      return onUnrefineAuthorization(state, action);
    case 'OnResetChangedPermissions':
      return onResetChangedPermissions(state, action);
    default:
      return state;
  }
}

function onInitAuthorizations(state, action) {
  return {
    ...state,
    authorizations: action.list
  };
}

function onSetAll(state, action) {
  const { authorizationId, userGroups, value } = action;
  const authorizationChangedPermissions = state.changedPermissions[authorizationId] || {};
  let changed = false;
  userGroups.forEach(userGroup => {
    if (!changed) {
      if (!authorizationChangedPermissions[userGroup.id]) {
        changed = true;
      } else if (authorizationChangedPermissions[userGroup.id].value !== value) {
        changed = true;
      }
    }
    authorizationChangedPermissions[userGroup.id] = { value };
  });
  return changed
    ? {
        ...state,
        disabledSave: false,
        changedPermissions: {
          ...state.changedPermissions,
          [authorizationId]: {
            ...authorizationChangedPermissions
          }
        }
      }
    : state;
}

function onInitUserGroups(state, action) {
  return {
    ...state,
    userGroups: action.userGroups
  };
}

function OnInitChangedPermissions(state, action) {
  return {
    ...state,
    changedPermissions: action.changedPermissions
  };
}

function OnInitDisabledSave(state, action) {
  return {
    ...state,
    disabledSave: action.disabledSave
  };
}

function onSetAuthorizationXUserGroupValue(state, action) {
  const { authorizationId, userGroupId, value } = action;
  const authorizationChangedPermissions = state.changedPermissions[authorizationId] || {};
  return {
    ...state,
    disabledSave: false,
    changedPermissions: {
      ...state.changedPermissions,
      [authorizationId]: {
        ...authorizationChangedPermissions,
        [userGroupId]: {
          ...authorizationChangedPermissions[userGroupId],
          value
        }
      }
    }
  };
}

function onSaveAuthorizationsXUserGroups(state) {
  return {
    ...state,
    disabledSave: true
  };
}

function onResetChangedPermissions(state) {
  return {
    ...state,
    changedPermissions: {}
  };
}

function onUnrefineAuthorization(state, action) {
  const { authorizationId } = action;
  const index = state.authorizations.findIndex(x => x.webAuthorizationId === authorizationId);
  return {
    ...state,
    authorizations: Object.assign([...state.authorizations], {
      [index]: {
        ...state.authorizations[index],
        authorizationXDocumentTypeXUserGroups: [],
        isRefined: false
      }
    })
  };
}
